module.exports = __webpack_public_path__ + "img/eshoy_gold_small.a553ebc1.png";